import { UpstackDataGrid } from '../UpstackDataGrid/UpstackDataGrid';
import { GridPreferences, PrefKey, gridInitialState } from '../../../store/User';
import { McpAccessProfile } from '../../../Api/McpAccess';
import {
  CreateMcpAccessActionsColumn,
  DefaultMcpAccessGridColumnDefs
} from '../../Pages/Admin/ColumnDefs/McpAccessGridColumnDefs';

export interface McpAccessProfilesTableProps {
  profiles: McpAccessProfile[];
  loading: boolean;
  submittingRotateId: string | null;
  submittingRevokeId: string | null;
  onRotate: (profile: McpAccessProfile) => void;
  onRevoke: (profile: McpAccessProfile) => void;
}

export const McpAccessProfilesTable = ({
  profiles,
  loading,
  submittingRotateId,
  submittingRevokeId,
  onRotate,
  onRevoke
}: McpAccessProfilesTableProps) => {
  const columns = [
    ...DefaultMcpAccessGridColumnDefs,
    CreateMcpAccessActionsColumn({ submittingRotateId, submittingRevokeId, onRotate, onRevoke })
  ];
  const gridSettings = {
    muiConfig: gridInitialState(columns),
    disabledFields: []
  } as unknown as GridPreferences;

  return (
    <UpstackDataGrid
      title="MCP Access Profiles"
      rows={profiles}
      columns={columns}
      loadingData={loading}
      page={'mcp_access_grid' as PrefKey}
      gridSettings={gridSettings}
      showSearch={false}
      rowPrimaryKeys={['access_id']}
      containerClassName="min-h-[20rem]"
      dataCy="mcp-access-profiles-grid"
    />
  );
};
